/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadedFile
 */
export interface UploadedFile {
    /**
     * 
     */
    index: number;
    /**
     * 
     */
    contentType: string;
}

/**
 * Check if a given object implements the UploadedFile interface.
 */
export function instanceOfUploadedFile(value: object): value is UploadedFile {
    if (!('index' in value) || value['index'] === undefined) return false;
    if ((!('contentType' in (value as Record<string, any>)) && !('content_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['contentType'] === undefined && (value as Record<string, any>)['content_type'] === undefined)) return false;
    return true;
}

export function UploadedFileFromJSON(json: any): UploadedFile {
    return UploadedFileFromJSONTyped(json, false);
}

export function UploadedFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadedFile {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'],
        'contentType': json['content_type'],
    };
}

export function UploadedFileToJSON(json: any): UploadedFile {
    return UploadedFileToJSONTyped(json, false);
}

export function UploadedFileToJSONTyped(value?: UploadedFile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'content_type': value['contentType'],
    };
}

